export function getStatusChanges(action, combatantMap, currentCombatantStateChanges, combatantModels) {

  //Copy the changes.
  let changes = {
    ...currentCombatantStateChanges
  };

  if (action.affectCasterStatus && Array.isArray(action.affectCasterStatus)) {

    //There is only one casterId in combatantMap, so no need for a loop
    const casterModel = combatantModels[combatantMap.casterId];
    if (casterModel.status === action.affectCasterStatus[0] || action.affectCasterStatus[0] === "*") {
      const existingChanges = changes.state[combatantMap.casterId] || {};
      changes.state[combatantMap.casterId] = {
        ...existingChanges,
        status: action.affectCasterStatus[1] //set status to "to" value in array
      };
    }
  }

  if (action.affectTargetStatus && Array.isArray(action.affectTargetStatus)) {
    combatantMap.targetIds.forEach(targetId => {

      //Get a model of this target. (within the loop of all selected targets)
      const targetModel = combatantModels[targetId];

      //Validate that targetModel's status is specified as the "from" in the Action... or that the action accepts any status ("*")
      if (targetModel.status === action.affectTargetStatus[0] || action.affectTargetStatus[0] === "*") {
        const existingChanges = changes.state[targetId] || {};
        changes.state[targetId] = {
          ...existingChanges,
          status: action.affectTargetStatus[1] //set status to "to" value in array
        };
      }

    });
  }

  //Reset status to NORMAL when dead
  //Loop through changes and Set status to NORMAL if HP is <= 0
  Object.keys(changes.state).forEach(combKey => {
    const model = changes.state[combKey]
    if (model.hp <= 0) {
      changes.state[combKey].status = "normal"
    }
  });


  return changes;
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/description/status.js